import ModalDefault from '../'
import {withModalInteraction} from '@cred/react-analytics/hoc'

const Modal = withModalInteraction(ModalDefault)

export default Modal
